module.exports = __webpack_public_path__ + "img/09戴召乾.8da367d7.jpg";